module.exports = __webpack_public_path__ + "static/media/axia.37f5692f.png";